import { ActivityRelatedType, ActivityType } from '~/models'

export type ApiResponse = {
  success: boolean
  message?: string
}

export async function createActivity(activityData: {
  type: ActivityType
  relatedType: ActivityRelatedType
  relatedId: string
  meta?: { [key: string]: any }
}): Promise<ApiResponse> {
  const response = await fetch('/api/app/activity', {
    body: JSON.stringify(activityData),
    method: 'POST',
  })
  const result = await response.json()
  if (!result.success) {
    console.error('Error creating activity', result.error)
    throw new Error(`Error creating activity: ${result.error}`)
  }
  return result
}
